import { useScreenOrientation } from '@vueuse/core';

export const EOrientation = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
} as const;
export type TOrientation = (typeof EOrientation)[keyof typeof EOrientation];

export function useDeviceType() {
  const breakpoints = useBreakpoints({
    xxs: 375,
    xs: 576,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1440,
    '3xl': 1660,
  });
  // Get SSR fallback based on a device type from User-Agent
  const ssrFallback = useServerDevice();
  const activeBreakpoint = computed(() => breakpoints.active().value || ssrFallback || 'xxs');
  const isMobile = computed(() => ['xxs', 'xs', 'sm'].includes(activeBreakpoint.value));
  const isTablet = computed(() => ['md'].includes(activeBreakpoint.value));
  const isDesktop = computed(() => ['lg', 'xl', '2xl', '3xl'].includes(activeBreakpoint.value));
  const { width, height } = useWindowSize();
  const { orientation } = useOrientation();
  const isPortraitMobile = computed(() => isMobile.value && orientation.value === EOrientation.PORTRAIT);

  return {
    isMobile,
    isTablet,
    isDesktop,
    activeBreakpoint,
    isPortraitMobile,
    windowWidth: width,
    windowHeight: height,
  };
}

export function useOrientation() {
  const screenOrientation = useScreenOrientation();
  const orientation = computed(() => {
    if (screenOrientation.orientation.value?.startsWith('portrait')) return EOrientation.PORTRAIT;
    return EOrientation.LANDSCAPE;
  });
  return { orientation };
}
